(function (ws) {
    'use strict';
    /**
     * @typedef {Object} Event - event object
     * @typedef {Object} Array - array object
     */
    ws.views.formComments = ws.views.googleAnalytics.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'quote_activity',
        GTM_EVENT_ACTION: 'comment',

        /**
         * Initialize override.
         */
        initialize: function() {
            this.sideUid = this.$('#site_id').val();

            this.storefront = (this.sideUid === 'quoting') ? globals.path.api.quoting.quotingCommon : globals.path.api.westcon.storefrontCommon;
            this.model = new ws.models.commentsModel(this.storefront);
            this.model.set({quoteId: $('#quoteCode').val()});

            //for spinner
            this.$saveButton = this.$('.qut-add-comment');
            this.$error = this.$('.error-message');

            this.render();
        },

        events: {
            'click .qut-add-comment': 'saveComment'
        },

        /**
         * Render override.
         */
        render: function() {
            // pre-populate error container
            this.$error.text(this.$error.data('error'));
        },

        /**
         * Save comment to the database.
         * @param {Event} ev - Event object
         */
        saveComment: function(ev) {
            ev.preventDefault();
            var $comment = this.$('.qut-add-comment-body');
            if (this.validateComment($comment)) {

                //enable Spinner
                this.$saveButton.addClass('spinner-before no-padding').prop('disabled', true);
                let encryptedMessage = $('#XSSValidationEnabled').val() === true || $('#XSSValidationEnabled').val() === 'true' ?  globals.encodeString($comment.val()) : $comment.val();
                this.model.save({
                    code: $(ev.currentTarget).data('code'),
                    comment: encryptedMessage
                }).done(function(response) {
                    this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
                    this.$saveButton.removeClass('spinner-before no-padding');
                    this.$saveButton.prop('disabled', false);

                    if (response.length > 0) {
                        this.updateComments(response);
                        $comment.val('');
                    }
                }.bind(this)).fail(function (error) {
                    this.$saveButton.removeClass('spinner-before no-padding');
                    this.$saveButton.prop('disabled', false);
                }.bind(this));
            }
        },

        /**
         * Comment field validation
         * @param {Object} $comment - comment textarea node
         */
        validateComment: function($comment) {
            this.$error.hide();

            if ($comment.val().trim() === '') {
                this.$error.show();
                return false;
            }

            return true;
        },

        /**
         * Update comments container to include a successfully saved comment.
         * @param {Array} data - Response data
         */
        updateComments: function(data) {
            var comments = document.createDocumentFragment();
            _.each(data, function(item) {
                var li = document.createElement('li');
                var footer = document.createElement('footer');
                var time = document.createElement('time');
                time.innerHTML = item.createdDate;
                var strong = document.createElement('strong');
                strong.innerHTML = ' | ' + item.ownerData.name;
                footer.appendChild(time);
                footer.appendChild(strong);
                li.appendChild(footer);

                var p = document.createElement('p');
                p.textContent  = item.comment;
                li.appendChild(p);
                comments.appendChild(li);
            });

            this.$('.qut-comments').html(comments);
        },

        checkAttackValue: function(e) {
            globals.attackValueCheck(e);
        }
    });
})(westcon);
